import { a } from './chunk-IMSWER4T.js';

var i=class{_client=a.instance;async setFieldLockState(t,e,r){return await(await this._client.put(`/product-fields/${t}`,{locked:e,locale_id:r})).data}async getProductFields(t,e){return (await this._client.get(`/product-fields?&product_id=${t}&${e.map((r,a)=>`locale_ids[${a}]=${r}`).join("&")}`)).data.data}};

export { i as a };
//# sourceMappingURL=chunk-QUG6OSJ7.js.map
//# sourceMappingURL=chunk-QUG6OSJ7.js.map